import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULTS = {
  // Branding
  logo_text_primary: "Invinci",
  logo_text_accent: "Fy",
  logo_image: null,
  logo_font_primary: '"Playfair Display", serif',
  logo_font_accent: '"Great Vibes", cursive',
  tagline: "Decoding Minds. Designing Futures.",
  free_slot_limit: 5,
  google_form_url: "https://docs.google.com/forms/d/e/PLACEHOLDER/viewform",

  // Contact
  contact_phone: "+91 70557 44980",
  contact_phone_tel: "+917055744980",
  contact_instagram: "_invincify_",
  contact_email: "hello@invincify.in",

  // Hero
  hero_image_primary: null,
  hero_image_secondary: null,
  hero_headline: "Decoding minds. Designing futures.",
  hero_subheadline:
    "One-on-one career counselling for students and parents — powered by scientific psychometric assessments and the DIMT.",
  hero_cta_primary: "Book Your Session",
  hero_cta_secondary: "Take Assessment",
  hero_stats: ["5+ Years Mentoring", "200+ Students Guided", "DIMT Certified"],

  // About
  about_eyebrow: "The Science",
  about_headline: "Career clarity, measured — not guessed.",
  about_description:
    "InvinciFy combines psychometric profiling with the DIMT framework to map your strengths into a career direction that actually fits.",
  about_features: [],

  // Process
  process_eyebrow: "How It Works",
  process_headline: "Three simple steps from confusion to clarity.",
  process_steps: [],
  process_step2_note: "Assessment link will be shared after booking.",

  // Differentiators
  diff_eyebrow: "What Makes The Difference",
  diff_headline: "Counselling that listens first, prescribes later.",
  diff_description: "",
  diff_items: [],

  // Founder
  founder_eyebrow: "Founder's Diary",
  founder_name: "Harshita Chawla",
  founder_subtitle:
    "Founder · Career Counsellor · Psychometry Practitioner · Ph.D. Research Scholar",
  founder_image: null,
  founder_mission_quote:
    "To help students discover their true potential and make career choices with clarity and confidence.",
  founder_paragraphs: [],
  founder_hats: [],

  // Testimonials
  testimonials_eyebrow: "Stories & Testimonials",
  testimonials_headline:
    "The proof is in the clarity students walk away with.",
  testimonials: [],

  // Gallery
  gallery_eyebrow: "Behind the Scenes",
  gallery_headline: "Moments from sessions, students, and stories shared.",
  gallery_description: "",
  gallery_items: [],

  // Pricing & Offers
  pricing_enabled: true,
  pricing_eyebrow: "Pricing & Offers",
  pricing_headline: "Simple, transparent pricing.",
  pricing_description: "",
  pricing_sticker_visible: true,
  pricing_sticker_text: "FLAT 50% OFF",
  pricing_sticker_subtext: "Limited time — launch offer",
  pricing_tiers: [],
  pricing_footnote: "",

  // Booking
  booking_eyebrow: "Reserve Your Seat",
  booking_headline: "Book a session. Get the clarity you deserve.",
  booking_offer_label: "Launch Offer",
  booking_offer_title: "First 5 students — absolutely free.",
  booking_zoom_title: "Zoom 1:1",
  booking_zoom_desc: "60-90 min personalised session, from anywhere.",
  booking_inperson_title: "In-Person 1:1",
  booking_inperson_desc: "Face-to-face session — perfect with parents.",

  // FAQ
  faq_eyebrow: "Frequently Asked",
  faq_headline: "Questions, answered.",
  faq_items: [],

  // Footer
  footer_description:
    "Science-backed career counselling for students and parents.",
  footer_closing_quote: "Let's make the difference, together.",
  footer_closing_quote_font: '"Great Vibes", cursive',
};

const SiteContentContext = createContext({
  content: DEFAULTS,
  refresh: () => {},
  loading: true,
});

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/site-content`);
      setContent({ ...DEFAULTS, ...res.data });
    } catch (e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ content, refresh, loading }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
